import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Observable, map } from 'rxjs';
import { SessionStorageService } from '../../../core/services/session-storage.service';
import { LogType } from '../../enums';
import { UserTraceLogService } from '../../services';

@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {
  constructor(
    private _sessionStorageService: SessionStorageService,
    private _userTraceLogService: UserTraceLogService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (globalThis.sigv.appContext.sigvRetailConfig.disableHttpInterceptor) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          try {
            event = event.clone({ body: event?.body?.data });
            const useLog = {} as any;
            const uri = event?.url?.split('/');
            useLog[_.last(uri) ?? 'REQUEST'] = event;
            this._userTraceLogService.setTraceLog(
              LogType.HTTP_RESPONSE,
              useLog
            );
          } catch (error) {}
        }
        return event;
      })
    );
  }
}
